var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.914 7.75C7.508 6.488 9.113 5.583 11 5.583c2.394 0 4.333 1.455 4.333 3.25 0 1.517-1.384 2.79-3.256 3.15-.587.112-1.077.585-1.077 1.184m0 3.25h.01M20.75 11a9.75 9.75 0 11-19.5 0 9.75 9.75 0 0119.5 0z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/questionMarkRounded.cb579a4a.svg";
export { SvgQuestionMarkRounded as ReactComponent };